/**
 * tutorScoreFormatter — comment le score du masteur s'écrit (l'ancienne `TutorScoreCardM.js`).
 *
 * Un taux arrive de 0 à 1 ; il s'écrit en pour cent arrondi, l'espace insécable avant le signe,
 * et « - » tant qu'il n'y a pas de mesure (la carte d'aujourd'hui l'écrit ainsi).
 */
import { type UITutorScorePeriod } from "../types/tutorCoquilleAccueil"
import { countLabel } from "./textFormatter"

const NBSP = " "

/** « 87 % », « - » sans mesure. */
export function percentLabel(ratio: number | null | undefined): string {
    if (ratio == null || Number.isNaN(ratio)) return "-"
    return `${Math.round(ratio * 100)}${NBSP}%`
}

/** Le rang s'affiche une fois le seuil d'activité atteint, ou en cumulé (la règle de l'ancienne carte). */
export function showsRank(period: UITutorScorePeriod, threshold: number, cumulative: boolean): boolean {
    return period.rank != null && (cumulative || period.livesCount >= threshold)
}

/** L'assiduité sous la moitié, avec au moins un live : l'axe passe en alerte. */
export function isPunctualityLow(period: UITutorScorePeriod): boolean {
    const punctuality = period.axes.find((axis) => axis.key === "punctuality")?.value
    return punctuality != null && punctuality < 0.5 && period.livesCount > 0
}

/**
 * Ce qui reste à faire sous le seuil d'activité du mois, en une ligne : « Encore 5 lives pour débloquer
 * ton score » tant qu'aucune mesure n'existe, « Encore 2 lives pour débloquer ton classement » quand le
 * score se lit déjà. `null` une fois le seuil atteint. Sur l'accueil, à la place de la progression et
 * de la phrase de l'ancienne carte (« Complète 5 lives pour débloquer le classement et ton score complet. »).
 */
export function scoreUnlockLabel(period: UITutorScorePeriod, threshold: number): string | null {
    const remaining = threshold - period.livesCount
    if (remaining <= 0) return null
    const unlocked = period.performance == null ? "ton score" : "ton classement"
    return `Encore ${countLabel(remaining, "live")} pour débloquer ${unlocked}`
}
